import { GetRalphOracleProps, RalphOracle, RalphOracleServiceCapabilities } from './ralphOracle.types'

export const ralphOracleService = ({ percentClient }: RalphOracleServiceCapabilities) => ({
  getOracle: ({ country }: GetRalphOracleProps) => percentClient.get<RalphOracle>(`/v1/admin/ralph/oracle/${country}`)
})
